if (!customElements.get('blog-sort')) {
  customElements.define(
    'blog-sort',
    class BlogSort extends HTMLElement {
      constructor() {
        super();
        this.select = this.querySelector('select');
        this.container = document.querySelector('[data-blog-sort-container]');

        if (this.select && this.container) {
          this.select.addEventListener('change', this.onSortChange.bind(this));
        }
      }

      onSortChange() {
        const items = Array.from(this.container.children);
        const sortValue = this.select.value;

        items.sort((a, b) => {
          switch (sortValue) {
            case 'date-asc':
              return Number(a.dataset.publishedAt) - Number(b.dataset.publishedAt);
            case 'title-asc':
              return a.dataset.title.localeCompare(b.dataset.title);
            case 'title-desc':
              return b.dataset.title.localeCompare(a.dataset.title);
            case 'date-desc':
            default:
              return Number(b.dataset.publishedAt) - Number(a.dataset.publishedAt);
          }
        });

        items.forEach((item) => this.container.appendChild(item));
      }
    },
  );
}
